<template>
  <div class="input-container">
    <ValidationProvider :rules="validations" ref="validation" slim>
      <div class="input-group">
        <input
          ref="input"
          :class="{empty: empty, error: !!validationError}"
          :value="fieldValue"
          :type="inputType"
          :autofocus="autofocus"
          v-on:input="onInput"
          v-model="value"
          v-on:blur="setShowPassword(false)"
          autocapitalize="none"/>
        <label class="field-name">{{ fieldText }}</label>
        <label v-if="!!validationError" class="top-left-label">{{ validationError }}</label>
      </div>
    </ValidationProvider>
    <img v-if="showPassword" src="../../assets/eye_blue.svg" v-on:click="onEyeClick(false)"/>
    <img v-else src="../../assets/eye.svg" v-on:click="onEyeClick(true)"/>
  </div>
</template>

<script>

export default {
  name: 'PasswordInputField',
  props: ['error', 'fieldText', 'fieldValue', 'updateInput', 'autofocus', 'validations'],
  data() {
    return {
      showPassword: false,
      validationError: null,
      value: '',
    };
  },
  computed: {
    empty() {
      return !this.fieldValue || this.fieldValue === '';
    },
    inputType() {
      return this.showPassword ? 'text' : 'password';
    },
  },
  methods: {
    setShowPassword(showPassword) {
      this.showPassword = showPassword;
    },
    focusOnInput() {
      this.$refs.input.focus();
    },
    onEyeClick(showPassword) {
      this.setShowPassword(showPassword);
      this.focusOnInput();
    },
    onInput(e) {
      this.$emit('input', e.target.value);
      this.updateInput(e.target.value);
    },
    async onSave() {
      this.validationError = null;
      const isValid = await this.$refs.validation.validate();
      if (!isValid.valid) {
        [this.validationError] = isValid.errors;
        const textField = this.$el;
        if (textField) {
          textField.classList.add('animation');
          setTimeout(() => textField.classList.remove('animation'), 1000);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @keyframes shake {
    0% { transform: translate(2px, 0); }
    50% { transform: translate(-2px, 0); }
    100% { transform: translate(2px, 0); }
  }

  .input-container {
    height: 40px;
    margin-bottom: 20px;

    &.animation {
      animation: shake 200ms infinite;
      animation-timing-function: linear;
    }

    .input-group {
      position: relative;
      width: 100%;
      height: 40px;

      .top-left-label {
        position: absolute;
        top: -13px;
        right: -2px;
        width: 100%;
        text-align: left;
        font-size: 11px;
        color: $riseup_gray_2
      }

      > input {
        font-size: 20px;
        width: 100%;
        height: 100%;
        padding: 10px 10px 10px 5px;
        display: block;
        border: 1px solid #9b9b9b;
        border-radius: 3px;

        &:disabled {
          color: $riseup_gray_2;
          border: 1px solid $riseup_gray_2;
          background-color: $riseup_gray_0;
        }

        &:disabled ~ .field-name {
          position: relative;
          top: -59px;
          font-size: 12px;
          color: $riseup_gray_2;
        }

        &:focus {
          outline: none;
          border: 1px solid #4a90e2;
        }

        &:focus ~ .field-name,
        &:valid ~ .field-name {
          position: relative;
          top: -59px;
          font-size: 12px;
          color: $riseup_blue;
          transition: 300ms ease all;
        }

        &.empty:not(:focus):not(:disabled) ~ .field-name {
          color: $riseup_gray_2;
          font-size: 20px;
          font-weight: normal;
          position: relative;
          pointer-events: none;
          right: 10px;
          top: -33px;
          transition: 300ms ease all;
        }

        &:not(.empty):not(:focus):not(:disabled):not(.error) {
          border: 1px solid $riseup_blue;
        }

        &:not(.empty).error {
          border: 1px solid $riseup_red;
        }

        &:not(.empty).error ~ .field-name {
          color: $riseup_red;
        }
      }
    }

    > img {
      position: relative;
      top: -31px;
      left: -220px;
    }
  }
</style>
